import React, { useState } from 'react';

import './Main.css';
import Logo from './holding/Logo';
import Footer from './holding/Footer';
import Button from 'react-bootstrap/Button';
import { Stack } from 'react-bootstrap';

function AmountDisplay({ amount, currency, locale }) {
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount);

  return <span>{formattedAmount}</span>;
}
function isNumeric(str) {
  return !isNaN(str) && !isNaN(parseInt(str));
}

export default function Main() {
  const [result, setResult] = useState(null);
  const [message, setMessage] = useState(null);
  const [emailClicked, setEmailClicked] = useState(null);
  const [data, setData] = useState({
    routingNumber: '',
    bankBalance: '',
    debitCard: 'Y',
    paycheckAmount: '',
    frequency: 'S',
    payType: 'D',
    timeAtBank: '',
    timeAtEmployer: '',
    timeAtAddress: '',
    score: '',
    kbb: '',
    kbbMultiplier: 0.6,
    kbbValue: 0,
    maxLoanCap: 25000,
    approvalAmount: 0,
    lienFee: '',
    ownVehicle: 'N',
    paperCheck: 'N',
  });

  function handleCalculate() {
    var n = 0;
    if (data.frequency === 'M') {
      n = 12;
      if (data.paycheckAmount < 800) {
        setMessage('Denied: Minimum net income not met');
        return;
      }
    }
    if (data.frequency === 'W') {
      n = 52;
      if (data.paycheckAmount < 200) {
        setMessage('Denied: Minimum net income not met');
        return;
      }
    }
    if (data.frequency === 'S') {
      n = 24;
      if (data.paycheckAmount < 400) {
        setMessage('Denied: Minimum net income not met');
        return;
      }
    }
    if (data.frequency === 'B') {
      n = 26;
      if (data.paycheckAmount < 400) {
        setMessage('Denied: Minimum net income not met');
        return;
      }
    }

    data.monthlyIncome = (parseFloat(data.paycheckAmount) * n) / 12;
    setResult(true);

    if (data.bankBalance < 100) {
      setMessage(
        'Denied: Non qualifying account (Bank Balance too low)'
      );
      return;
    }
    if (data.debitCard !== 'Y') {
      setMessage('Denied: Debit card does not have customer name');
      return;
    }
    if (data.monthlyIncome < 800) {
      setMessage('Denied: Minimum net income not met');
      return;
    }
    if (data.payType !== 'D') {
      setMessage(
        'Denied: Paycheck is not direct deposited to account'
      );
      return;
    }
    if (data.timeAtBank < 1) {
      setMessage('Denied: Minimum account age not met');
      return;
    }
    if (data.timeAtEmployer < 1) {
      setMessage('Denied: Minimum time at job not met');
      return;
    }
    if (data.timeAtAddress < 1) {
      setMessage('Denied: Time at current address not sufficient');
      return;
    }
    if (data.score < 400) {
      setMessage('Denied: Low Teletrack Score');
      return;
    }
    if (
      !isNumeric(data.routingNumber) ||
      data.routingNumber.length !== 9
    ) {
      setMessage('Denied: Invalid routing number');
      return;
    }

    console.log(
      'KBB: ' + data.kbb + ', Multiplier: ' + data.kbbMultiplier
    );

    data.kbbValue = parseFloat(data.kbb) * data.kbbMultiplier;
    console.log('KBB value: ' + data.kbbValue);
    var approvalAmount;
    if (data.kbbValue < 5000)
      approvalAmount = Math.min(data.monthlyIncome, data.kbbValue);
    else approvalAmount = Math.min(data.kbbValue, data.maxLoanCap);

    console.log('Pre approval amount: ' + approvalAmount);
    approvalAmount = approvalAmount + parseFloat(data.lienFee);

    data.approvalAmount = approvalAmount;

    console.log('Approval amount: ' + data.approvalAmount);
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  function handleEmailLoan() {
    if (emailClicked) setEmailClicked(null);
    else setEmailClicked(true);
  }

  return (
    <div className="apply-now">
      <Logo />
      <div className="main">
        <div className="container calculator">
          <div className="row">
            <div className="col-4 col-lg-4 col-md-4">
              <div className="form-group">
                <label className="form-label">
                  Enter Routing Number (9-digits):
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="routingNumber"
                  value={data.routingNumber}
                  onChange={handleChange}
                  maxLength={9}
                  minLength={9}
                  tabIndex={1}
                />
              </div>

              <div className="form-group">
                <label for="debitCard" className="form-label">
                  Does the debit card have the customers name printed
                  on it?
                </label>
                <select
                  name="debitCard"
                  className="form-control"
                  value={data.debitCard}
                  onChange={handleChange}
                  tabIndex={3}
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div className="form-group">
                <label for="payType" className="form-label">
                  Select payment type
                </label>
                <select
                  name="payType"
                  className="form-control"
                  value={data.payType}
                  onChange={handleChange}
                  tabIndex={6}
                >
                  <option value="D">Direct Deposit</option>
                  <option value="P">Paper Check</option>
                </select>
              </div>

              <div className="form-group">
                <label for="timeAtBank" className="form-label">
                  How long with current employer (months)?
                </label>
                <input
                  type="text"
                  name="timeAtEmployer"
                  className="form-control"
                  value={data.timeAtEmployer}
                  onChange={handleChange}
                  tabIndex={8}
                />
              </div>

              <div className="form-group">
                <label for="score" className="form-label">
                  <br />
                  Enter Score:
                </label>
                <input
                  type="text"
                  name="score"
                  className="form-control"
                  value={data.score}
                  onChange={handleChange}
                  tabIndex={10}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label for="bankBalance" className="form-label">
                  Enter current bank balance
                </label>
                <input
                  type="text"
                  name="bankBalance"
                  className="form-control"
                  value={data.bankBalance}
                  onChange={handleChange}
                  tabIndex={2}
                />
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">
                      Enter Paycheck Amount:
                    </label>
                    <input
                      type="text"
                      name="paycheckAmount"
                      className="form-control"
                      value={data.paycheckAmount}
                      onChange={handleChange}
                      tabIndex={4}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">
                      Select Pay Frequency:
                    </label>
                    <select
                      name="frequency"
                      className="form-control"
                      value={data.frequency}
                      onChange={handleChange}
                      tabIndex={5}
                    >
                      <option value="B">Bi-Weekly</option>
                      <option value="W">Weekly</option>
                      <option value="S">Semi-Monthly</option>
                      <option value="M">Monthly</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label for="timeAtBank" className="form-label">
                  Bank account open for (months)?
                </label>
                <input
                  type="text"
                  name="timeAtBank"
                  className="form-control"
                  value={data.timeAtBank}
                  onChange={handleChange}
                  tabIndex={7}
                />
              </div>
              <div className="form-group">
                <label for="timeAtAddress" className="form-label">
                  How long at current residence (months)?
                </label>
                <input
                  type="text"
                  name="timeAtAddress"
                  className="form-control"
                  value={data.timeAtAddress}
                  onChange={handleChange}
                  tabIndex={9}
                />
              </div>

              <div className="form-group">
                <label for="ownVehicle" className="form-label">
                  Do you own a vehicle outright (no payments) with a
                  clear title, registered in your name?
                </label>
                <select
                  name="ownVehicle"
                  className="form-control"
                  value={data.ownVehicle}
                  onChange={handleChange}
                  tabIndex={6}
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div className="form-group">
                <div className="row">
                  {data.ownVehicle === 'Y' ? (
                    <div className="col-6">
                      <label for="kbb" className="form-label">
                        KBB Value:
                      </label>
                      <input
                        type="text"
                        name="kbb"
                        className="form-control"
                        value={data.kbb}
                        onChange={handleChange}
                        tabIndex={11}
                      />
                    </div>
                  ) : (
                    <div className="col-6">
                      <label for="paperCheck" className="form-label">
                        Do you have a paper check?
                      </label>
                      <select
                        name="paperCheck"
                        className="form-control"
                        value={data.paperCheck}
                        onChange={handleChange}
                        tabIndex={6}
                      >
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                      </select>
                    </div>
                  )}
                  <div className="col-6">
                    <label for="lienFee" className="form-label">
                      Lien Fee:
                    </label>
                    <input
                      type="text"
                      name="lienFee"
                      className="form-control"
                      value={data.lienFee}
                      onChange={handleChange}
                      tabIndex={12}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              {result ? (
                <Stack gap={2} className="calc-right">
                  <h2 className="text-center">Your results</h2>
                  {message ? (
                    <div className="text-danger pt-5">{message}</div>
                  ) : (
                    <div>
                      <h3>Monthly Income</h3>
                      <div className="amount">
                        <AmountDisplay
                          amount={data.monthlyIncome}
                          currency="USD"
                          locale="en-US"
                        />
                      </div>
                      <h3>Approval Amount</h3>
                      <div className="amount">
                        <AmountDisplay
                          amount={data.approvalAmount}
                          currency="USD"
                          locale="en-US"
                        />
                      </div>
                      <h3>Total interest</h3>
                      <div className="amount">
                        <AmountDisplay
                          amount={data.interest}
                          currency="USD"
                          locale="en-US"
                        />
                      </div>
                      <h3>Total cost of finance</h3>
                      <div className="amount">
                        <AmountDisplay
                          amount={data.totalCost}
                          currency="USD"
                          locale="en-US"
                        />
                      </div>
                    </div>
                  )}
                </Stack>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          <Button
            variant="primary"
            type="submit"
            className="calc-button"
            onClick={handleCalculate}
          >
            Calculate
          </Button>
          <Button
            variant="warning"
            type="button"
            className="email-loan-offer-button"
            onClick={handleEmailLoan}
          >
            Email Loan Offer
          </Button>
          {emailClicked ? (
            <div className="email-loan-offer">
              <label for="lienFee" className="form-label">
                Email address:
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={data.email}
                onChange={handleChange}
                tabIndex={20}
              />
              <Button
                variant="secondary"
                type="button"
                className="calc-button"
                onClick={handleEmailLoan}
              >
                Send
              </Button>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
